import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../../endpoints/endpoint';
import { NetworkService } from '../../../services/network.service';
import { Utility } from '../../../utility/utility';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-product-relation-ship-view',
  templateUrl: './product-relation-ship-view.component.html',
  styleUrls: ['./product-relation-ship-view.component.css']
})
export class ProductRelationShipViewComponent implements OnInit, OnDestroy {

  settingsFilter ={
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      lead:{
        title: 'LO',
        filter: false,
        sort:false
      },
      owner:{
        title:'BO',
        filter: false,
        sort:false
      },
      globalCustomerName: {
        title: 'Global Customer Name',
        filter: false,
        sort:false
      },
      country: {
        title: 'Country',
        filter: false,
        sort:false
      },
      localCustomer: {
        title: 'Local Customer',
        filter: false,
        sort:false
      },
      localCustomerName: {
        title: 'Local Customer Name',
        filter: false
      },
      
      productId: {
        title: 'Asset Id',
        filter: false,
        sort:false
      },
      productOrderId: {
        title: 'Order Id',
        filter: false,
        sort:false
      },
      productName: {
        title: 'Product Name',
        filter: false,
        sort:false
      },
      msimsdn: {
        title: 'MSISDN',
        filter: false,
        sort:false
      },
      


    },
    pager:{
      display:false,
      perPage:10
    }
  };

  settings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      optionName:{
        title:'Option'
      },
      orderDate:{
        title: 'Order Date',
        compareFunction(direction: any, a: string, b: string) {
          let dateObjectA: any;
          let dateObjectB: any;
          if (a) {
            let datePartsA = a.split("/");
            let timePartsA = datePartsA[2].split(" - ")[1].split(":");
            datePartsA[2] = datePartsA[2].split(" - ")[0];
            dateObjectA = new Date(+datePartsA[2], +datePartsA[1] - 1, +datePartsA[0], +timePartsA[0], +timePartsA[1], +timePartsA[2]);
            console.log(dateObjectA);
          }
          if (b && dateObjectA) {
            let datePartsB = b.split("/");
            let timePartsB = datePartsB[2].split(" - ")[1].split(":");
            datePartsB[2] = datePartsB[2].split(" - ")[0];
            dateObjectB = new Date(+datePartsB[2], +datePartsB[1] - 1, +datePartsB[0], +timePartsB[0], +timePartsB[1], +timePartsB[2]);

            console.log(dateObjectB);
          }

          
          if (dateObjectA < dateObjectB) {
            return -1 * direction;
          }
          if (dateObjectA > dateObjectB) {
            return direction;
          }

          return 0;
        }
      },
      
      


    }
  };

  settingsHandset = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      optionName:{
        title:'HANDSET'
      },
      imei:{
        title:'IMEI'
      },
    

          
    
      
      


    }
  };


  listRelationship: any[] = [];
  listHandset: any[] = [];
  inventory: any = {};
  idProduct: string;
  destroy$ = new Subject<boolean>();

  constructor(private route: ActivatedRoute, private networkService: NetworkService, private router: Router, 
    private toastr: ToastrManager, private spinner: NgxSpinnerService) { }

  

  ngOnInit(): void {
    this.idProduct = this.route.snapshot.params['idProduct'];
    this.initiliazeRelationship();
  }

  initiliazeRelationship() {
    this.spinner.show("sp1");
    let urlgetProductRelationship: string = environment.basePath + _ENDPOINT.getProductRelationship;
     let data = Utility.createBodyForPostRequest(this.idProduct, true);
    this.networkService.post(urlgetProductRelationship, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            let dataJson = JSON.parse(response.body);
            this.inventory = dataJson.inventory;
            this.listRelationship = dataJson.listRelationship;
            this.listHandset=dataJson.listHandset;
            this.spinner.hide("sp1");
          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during relationship retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['catalog-view']);
          }
        }
        else{
          if(response && response.inventory && response.listRelationship){
            this.inventory = response.inventory;
            this.listRelationship = response.listRelationship;
            this.listHandset=response.listHandset;
            this.spinner.hide("sp1");
          }else if(response && response.length && response.length>0 ){
            this.spinner.hide("sp1");
            this.toastr.errorToastr(response, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['catalog-view']);
          }else{
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during relationship retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['catalog-view']);
          }
        }

        
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during relationship retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
          this.router.navigate(['inventory-view']);
        });;
  }

  goToInventoryView(){
    this.router.navigate(['inventory-view']);
  }

  viewHandset(){
    let res:boolean= false;
    if(this.listHandset && this.listHandset.length>0){
      res=true;
    }
    return res;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
